import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { store } from '../../../../store';

const useModalState = () => {
  const history = useHistory();
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { handleNext } = state.user;

  return { history, state, dispatch, handleNext };
};

export default useModalState;
